module.exports = __webpack_public_path__ + "static/media/closed-eye-75.5a0a911e.svg";